import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";

import { Section, Title, Text, Span } from "../../components/Core";
import imgPhoto from "../../assets/image/png/portrait-about.png";
import { Viber } from "styled-icons/fa-brands";
import { Instagram } from "styled-icons/fa-brands";
import { Telegram } from "styled-icons/fa-brands";


const ViberIcon = styled(Viber)`
  color: white;
`;
const InstagramIcon = styled(Instagram)`
  color: white;
`;
const TelegramIcon = styled(Telegram)`
  color: white;
`;

const LinkSocial = styled.a`
  color: ${({ theme }) => theme.colors.light} !important;
  font-weight: bold;
  &:hover {
    color: ${({ theme }) => theme.colors.light} !important;
    transform: translateY(-5px);
  }
`;

const About = ({ hero = true, bg = "dark", ...rest }) => {
  return (
    <>
      <Section hero={hero} bg={bg} {...rest}>
        <Container>
          <Row className="align-items-center">
            <Col lg="6">
              <div>
                <img src={imgPhoto} alt="folio" className="img-fluid" />
              </div>
            </Col>
            <Col lg="6">
              <div className="pl-lg-4 pt-5 pt-lg-0">
                <Title color="light" variant="secSm">
                  Татьяна Луковская
                </Title>
                <Text
                  color="light"
                  className="mt-3 mt-lg-5"
                  css={`
                    line-height: 1.5;
                  `}
                >
                  С вязанием неразлучна больше 10 лет. Создаю качественные и стильные вещи.
                </Text>
                <Text color="light" className="mt-4">
                  В моих изделиях красиво, тепло и уютно.
                </Text>
                <div className="mt-4">
                  <Text color="light">Напишите мне</Text>

                  <Text variant="p">
                    <a
                      href="mailto:tatsiana@tlknitting.com"
                      className="font-weight-bold"
                    >
                      <Span color="light">tatsiana@tlknitting.com</Span>
                    </a>
                  </Text>
                </div>
                <div className="mt-5 d-flex">
                  <LinkSocial
                    href="https://www.instagram.com/tl_knitting"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mr-3"
                  >
                    <InstagramIcon size={"30"}/>
                  </LinkSocial>
                  <LinkSocial
                    href="https://t.me/tanya_lukovskaya"
                    target="_blank"
                    rel="noopener noreferrer"
                    className=" mr-3"
                  >
                    <TelegramIcon size={"30"}/>
                  </LinkSocial>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Section>
    </>
  );
};

export default About;
